module.exports = __webpack_public_path__ + "static/0050-cc43d1832387ad065ca4321022a5f090.png";